<script>
	import Button from "./Button.svelte";

	let d = 0;

	let getD = function () {
		return d++;
	};

	let links = [
		{ title: "Pee-Mail", url: "https://pee-mail.com" },
		{ title: "Lousy NFT", url: "https://lousygif.com/nft" },
		{ title: "Lousy GIF", url: "https://lousygif.com" },
		{ title: "meremirror", url: "https://www.meremirror.com/" },
		{ title: "Selfsmooch", url: "https://bit.ly/selfsmooch" },
		{ title: "Work", url: "https://karlackermann.com" },
	];
</script>

<svelte:head>
	<title>@karl.ackermann</title>
</svelte:head>

<main style="text-align:center">
	<div class="" style={"animation-delay: -" + getD() * 0.07 + "s"}>
		<img
			class="portrait"
			src="profilePic_opt_512x512.jpg"
			alt="portrait of a very handsome man"
		/>
	</div>
	<div class="shake social-link" style={"animation-delay: -" + getD() + "s"}>
		<p>
			<a href="https://www.instagram.com/karl.ackermann/">@karl.ackermann</a>
		</p>
	</div>

	<div>
		{#each links as link}
			<div class="shake" style={"animation-delay: -" + getD() + "s"}>
				<Button {...link} />
			</div>
		{/each}
	</div>
</main>
<style>
	@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap');
	main {
		text-align: center;
		padding: 1em;
		max-width: 100%;
		margin: 0 auto;
	}
	@media (min-width: 1080px) {
		main {
			max-width: 75%;
		}
	}

	/* instagram linktree template */

	:global(body) {
		width: 100%;
		height: 100%;
		color: #fff;
		background: linear-gradient(
			-45deg,
			#e73c7e,
			#23a6d5,
			#23d5ab,
			#23a6d5,
			#e73c7e,
			#23a6d5,
			#23d5ab
		);
		background-size: 400% 400%;
		animation: Gradient 10s ease infinite;
		font-family: "Roboto", sans-serif;
		letter-spacing: .07rem;
	}

	.social-link a{
		text-decoration: none;
		color: white;
	}

	@keyframes Gradient {
		0% {
			background-position: 0% 0%;
		}
		50% {
			background-position: 100% 100%;
		}
		100% {
			background-position: 0% 0%;
		}
	}

	.shake {
		animation: shake-animation 1.25s ease-in-out infinite;
		transform-origin: 50% 50%;
	}

	@keyframes shake-animation {
		0% {
			transform: translate(0, 0);
		}
		50% {
			transform: translate(10px, 0);
		}
		100% {
			transform: translate(0, 0);
		}
	}

	.portrait {
		border-radius: 3000px;
		width: 128px;
		height: auto;
	}
</style>
